export default "__VITE_ASSET__CE1Q48KW__"